export default {
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    tLabel: {
      type: String,
      required: false,
      default: ''
    },
    tooltip: {
      type: String,
      required: false,
      default: ''
    },
    tTooltip: {
      type: String,
      required: false,
      default: ''
    },
    hasFormGroup: {
      type: Boolean,
      required: false,
      default: true
    },
    allowEmpty: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    labelColsSm: {
      type: String | Number | Boolean,
      required: false,
    },
    labelColsMd: {
      type: String | Number | Boolean,
      required: false,
    },
    labelColsLg: {
      type: String | Number | Boolean,
      required: false,
    },
    labelColsXl: {
      type: String | Number | Boolean,
      required: false,
    },
    contentColsSm: {
      type: String | Number | Boolean,
      required: false,
    },
    contentColsMd: {
      type: String | Number | Boolean,
      required: false,
    },
    contentColsLg: {
      type: String | Number | Boolean,
      required: false,
    },
    contentColsXl: {
      type: String | Number | Boolean,
      required: false,
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      ready: true,
      selectedOption: null,
      options: [],
    }
  },
  mounted() {
    this.$emit("ready", this.ready);
    this.selectedOption = this.findByValue(this.value)
  },
  created() {
    // set your options overwriting this method

    // this.options = [
    //   {
    //     id: 1,
    //     label: this.$tc("Within {count} month(s)", 1, {count: 1}),
    //     value: 1
    //   },
    //   {
    //     id: 2,
    //     label: this.$tc("Within {count} month(s)", 2, {count: 2}),
    //     value: 2,
    //   },
    // ];

    // this.loading = false;
  },
  methods: {
    clearValue() {
      this.selectedOption = null;
    },
    findByValue(value) {
      if (value === undefined) {
        return null;
      }

      return this.options.find(option =>
        value.toString() === option?.value?.toString()
      ) || null;
    },
  },
  computed: {
    computedLabel() {
      return this.tLabel ? this.$t(this.tLabel) : this.label;
    },
    computedTooltip() {
      return this.tTooltip ? this.$t(this.tTooltip) : this.tooltip;
    },
    showClearIcon() {
      return this.allowEmpty && this.selectedOption;
    },
  },
  watch: {
    selectedOption(newValue) {
      this.$emit('input', newValue ? newValue.value : null);
    },
    value(newValue) {
      this.selectedOption = this.findByValue(newValue);
    },
  },
};
